import(/* webpackMode: "eager" */ "/tmp/8deb9be30f8b305/app/[locale]/error.tsx");
